var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTerminalMovilappditopay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 196,
    height: 196,
    viewBox: "0 0 196 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_9",
    x: 0,
    y: 0,
    width: 196,
    height: 196,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Terminal_Movil_app_dito_pay",
    "data-name": "Terminal Movil app dito pay",
    transform: "translate(-1341 -1787)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1341, 1787)",
    filter: "url(#Trazado_9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9-2",
    "data-name": "Trazado 9",
    d: "M89,0A89,89,0,1,1,0,89,89,89,0,0,1,89,0Z",
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    transform: "translate(1356.6 1840)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M19.922,75.172a2.146,2.146,0,0,0-1.859,2.391v1.328a2.146,2.146,0,0,0,1.859,2.391h5.313a2.146,2.146,0,0,0,1.859-2.391V77.563a2.146,2.146,0,0,0-1.859-2.391ZM3.719,10.625V71.453H40.906V10.625Zm10.89-7.437v.266c-.531,0-.8.531-.8,1.063-.266.531.266.8.8.8H31.344c.531,0,.8-.531.8-1.062a1.186,1.186,0,0,0-.8-1.063ZM5.047,0h34.8a5.28,5.28,0,0,1,5.047,5.313V79.688A5.107,5.107,0,0,1,39.844,85H5.047A5.28,5.28,0,0,1,0,79.688V5.313A5.107,5.107,0,0,1,5.047,0Z",
    transform: "translate(60.4)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalMovilappditopay);
export default __webpack_public_path__ + "static/media/Terminal Movil app dito pay.40a46422b2509a3cdb7c3415bc0523c3.svg";
export { ForwardRef as ReactComponent };